// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd954327","453":"03346f77","455":"8bd144bc"}[chunkId] + ".chunk.js";
};